"use client";

import { useEffect, useRef } from "react";

const AW_ID = "AW-18089241893";

export function useSignupConversion(shouldFire: boolean) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!shouldFire || firedRef.current) return;
    firedRef.current = true;

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
    }
    gtag("js", new Date());
    gtag("config", AW_ID);
  }, [shouldFire]);
}
